require('./css/insights.scss');
require('./css/playbacks.scss');
require('./css/billing.scss');
require('./css/invoices.scss');
require('./css/creation_flows.scss');
require('./css/icons.scss');
require('./css/incoming.scss');

require('../polls/components/bar-chart-with-table/bar-chart-with-table.component.scss');

require('./css/generic.scss');
require('./css/login_register.scss');
require('./css/charts.scss');

require('./css/modals/modal-billing-warning.scss');
require('./components/billing/payment-method-warning-card/payment-method-warning-card.component.scss');
require('./components/nps-trademark-message/nps-trademark-message.component.scss');
require('./js/components/password-field/password-field.component.scss');

// Load angular dependency modules
require('./js/modules/account.module.js');
require('./js/modules/api.module.js');
require('./js/modules/logging.module.js');
require('./js/modules/models.module.js');
require('./js/modules/plans.module.js');
require('./js/modules/profile.module.js');
require('./js/modules/segments.module.js');
require('./js/modules/buttons.module.js');
require('./js/modules/settings.module.js');
require('./js/modules/storage.module.js');
require('./js/modules/tracking.module.js');
require('./js/modules/ui.module.js');
require('./js/modules/utils.module.js');
require('./js/modules/user.module.js');
require('./js/modules/react.module.js');
require('./js/modules/revenue.module.js');
require('./js/modules/forms.module.js');
require('./js/modules/feedback.module.js');
require('./js/modules/surveys.module.js');
require('./js/modules/site.module.js');

require('./js/app.js');
require('./components/app/app.component.js');
require('./js/controllers/app-ctrl.js');

// Modals
require('./js/services/modals/modal-grant-support-access.js');
require('./js/services/modals/modal-prompt.js');

require('./js/controllers/modals/invoices/modal-update-purchase-order.js');

require('./js/controllers/modals/billing/modal-billing-warning.js');

require('./js/controllers/modals/modal-grant-support-access.js');

require('./js/components/user-data-loader/user-data-loader.component.js');
require('./js/directives/feature.js');
require('./js/directives/highlight-content.js');
require('./js/directives/list-filter.js');
require('./js/directives/loader.js');
require('./js/directives/notification.js');
require('./js/directives/paging.js');
require('./components/nps-trademark-message/nps-trademark-message.component.js');
require('./js/directives/sortable-table.js');
require('./js/directives/sticky-flow-section.js');
require('./js/directives/ui-helper.js');
require('./js/directives/ng-click-with-loader.js');
require('./js/components/password-field/password-field.component.js');

require('./js/components/verification-code-modal/verification-code-modal.component.js');

// Billing components
require('./components/billing/payment-method-warning-card/payment-method-warning-card.component.js');

require('./js/filters/capitalize.js');
require('./js/filters/datetime.js');
require('./js/filters/language.js');
require('./js/filters/trust.js');
require('./js/filters/urls-to-links.js');

require('./js/services/billing/invoices/modal-update-purchase-order.js');
require('./js/services/billing/invoices/invoice.js');
require('./js/services/billing/braintree.js');
require('./js/services/billing/modal-billing-warning.js');
require('./js/services/billing/vat.js');
require('./js/services/billing/payments.js');
require('./js/services/billing/churn-survey.js');

require('./js/services/billing/v2/subscription.js');
require('./js/services/billing/v2/price.js');

require('./js/services/tracking/beamer.js');
require('./js/services/tracking/contentsquare.js');
require('./js/services/tracking/hotjar-tracking.js');
require('./js/services/tracking/segment.js');
require('./js/services/tracking/track.js');
require('./js/services/account.js');
require('./js/services/campaigns.js');
require('./js/services/colorhelper.js');
require('./js/services/crosstab.js');
require('./js/services/download-blob.js');
require('./js/services/feature.js');
require('./js/services/ask-feature.js');
require('./js/services/gqsr.js');
require('./js/services/help.js');
require('./js/services/next-item-data.js');
require('./js/services/notify.js');
require('./js/services/organization.js');
require('./js/services/loader.js');
require('./js/services/organization.js');
require('./js/services/page.js');
require('./js/services/plan.js');
require('./js/services/rest-default-handlers.js');
require('./js/services/site.js');
require('./js/services/storage.js');
require('./js/services/targeting-rule.js');
require('./js/services/tracking-code.js');
require('./js/services/ui-helper.js');
require('./js/services/user.js');
require('./js/services/userdata.js');
require('./js/services/billing/allowances.js');

require('./js/services/window-title.js');

require('./js/utils/use-notify-provider.ts');

require('../feedback/js/controllers/feedback-edit-create-ctrl.js');
require('../feedback/js/controllers/feedback-responses-ctrl.js');
require('../feedback/js/services/default-feedback-data.js');

require('../polls/js/controllers/polls-edit-create-ctrl.js');
require('../polls/js/models/poll.js');
require('../polls/js/services/polls.js');
require('../polls/js/services/survey-query.js');
require('../polls/js/services/react-navigation.js');
require('../polls/js/services/feedback-query.js');

require('../settings/js/controllers/billingV2-ctrl.js');
require('../settings/js/controllers/invoices-ctrl.js');

require('./js/app-routing.js');
